import React, { Component } from "react";
import { connect } from "react-redux";
import { getEnachFoliosList } from "../../../../store/actions/transactions";
import {
  EnachUMR,
  EnachFolio,
  Enachbank,
  EnachEndDate,
  EnachMaxAmount,
  EnachStartDate,
} from "../../../../store/actions/auth";
import IntegrationReactSelect from "../../../forms/autoCompleteInput";

class SipEnach extends Component {
  constructor(props) {
    super(props);
    const fund = "189";
    const folios = this.props.fundList.reduce((prev, curr) => {
      if (curr.Fund.trim() === fund) {
        return [...prev, curr.Acno];
      }
      return prev;
    }, []);
    this.state = {
      folios: folios,
      folio: { value: "" },
      details: [],
    };
  }

  async componentDidMount() {
    const { investorData } = this.props;
    this.props.EnachUMR("");
    this.props.EnachFolio("");
    this.props.Enachbank("");
    const fund = "189";
    const folios = this.props.fundList.reduce((prev, curr) => {
      if (curr.Fund.trim() === fund) {
        return [...prev, curr.Acno];
      }
      return prev;
    }, []);

    const params = {
      Fund: "189",
      PAN: investorData.PAN,
      uid: this.props.userId,
      customfund: "189",
      acno: folios[0],
    };
    const response = await this.props.getEnachFoliosList(params);
    if (!!response && !!response.Table1 && !!response.Table1.length) {
      this.setState({
        details: response.Table1,
      });
    }
    this.setState({
      folio: { value: { value: folios[0], label: folios[0] } },
    });
  }

  ChangeFolio = async (value) => {
    const { investorData } = this.props;
    if (!!value) {
      this.setState({
        folio: { value: value },
      });
      const params = {
        Fund: "189",
        PAN: investorData.PAN,
        uid: this.props.userId,
        customfund: "189",
        acno: value.value,
      };
      const response = await this.props.getEnachFoliosList(params);
      if (!!response && !!response.Table1 && !!response.Table1.length) {
        this.setState({
          details: response.Table1,
        });
      } else {
        this.setState({
          details: [],
        });
      }
    }
  };
  gotoSIP = (ele) => async () => {
    await this.props.EnachEndDate(ele["MANDATE END DATE"]);
    await this.props.EnachStartDate(ele["MANDATE START DATE"]);
    await this.props.EnachMaxAmount(ele.Amt);
    await this.props.EnachUMR(ele.UMRNNO);
    await this.props.Enachbank(ele["BANK A/C NO"]);
    this.props.history.push({
      pathname: `/new-transaction/sip/digital/modes/enach-folios/transact`,
      state: {
        enachSipDetails: ele,
        mode: "ENACH",
        folio: this.state.folio.value.value,
      },
    });
  };

  gotoENACH = () => {
    this.props.EnachFolio(this.state.folio.value.value);
    this.props.history.push({
      pathname: `/new-transaction/sip/digital/modes/enach-folios/eNACH`,
      state: {
        folio: this.state.folio.value.value,
      },
    });
  };
  render() {
    const { folio, folios, details } = this.state;

    return (
      <div className="enach-sip" style={{ minHeight: "75vh" }}>
        <div className="enach-sip-start">
          <div className="enach-sip-title">
            Summary of ENACH registered under the folio number
          </div>
          <div className="input-margin" style={{ width: 300, marginLeft: 10 }}>
            <div className="input-name input-integrated-label">
              Please select Folio
            </div>
            <IntegrationReactSelect
              suggestions={folios.map((item) => ({
                label: item,
                value: item,
              }))}
              value={folio.value}
              placeholder="Select Folio"
              handleChange={this.ChangeFolio}
              inputRef={(ele) => (this.folioField = ele)}
              isError={folio.isError}
              errorMessage={folio.errorMessage}
            />
          </div>
        </div>
        {!!details.length ? (
          <div className="input-margin Table_Sec">
            <div className="input-name">Select Bank to Register ENACH</div>
            <div style={{ marginBottom: 20 }} className="Enach-Sip-Responsive">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#005DAC",
                  padding: "10px 5px",
                  color: "white",
                  fontFamily: "Rubik-Regular",
                }}
              >
                <div
                  style={{
                    flexGrow: 1,
                    flexBasis: 0,
                    padding: "0px 5px",
                    textAlign: "center",
                  }}
                >
                  Bank Account Number
                </div>
                <div
                  style={{
                    flexGrow: 1,
                    flexBasis: 0,
                    padding: "0px 5px",
                    textAlign: "center",
                    maxWidth: 100,
                  }}
                >
                  IFSC Code
                </div>
                <div
                  style={{
                    flexGrow: 1,
                    flexBasis: 0,
                    padding: "0px 5px",
                    textAlign: "center",
                  }}
                >
                  Bank Name
                </div>
                <div
                  style={{
                    flexGrow: 1,
                    flexBasis: 0,
                    padding: "0px 5px",
                    textAlign: "center",
                  }}
                >
                  UMR No
                </div>
                <div
                  style={{
                    flexGrow: 1,
                    flexBasis: 0,
                    padding: "0px 5px",
                    textAlign: "center",
                  }}
                >
                  Mandate Start Date
                </div>
                <div
                  style={{
                    flexGrow: 1,
                    flexBasis: 0,
                    padding: "0px 5px",
                    textAlign: "center",
                  }}
                >
                  Mandate End Date
                </div>
                <div
                  style={{
                    flexGrow: 1,
                    flexBasis: 0,
                    padding: "0px 5px",
                    textAlign: "center",
                  }}
                >
                  Amount
                </div>
                <div
                  style={{
                    flexGrow: 1,
                    flexBasis: 0,
                    padding: "0px 5px",
                    textAlign: "center",
                  }}
                >
                  Please click "select" to register ENACH SIP
                </div>
              </div>
              {details.map((ele, index) => (
                <div
                  style={{
                    display: "flex",
                    padding: "10px 5px",
                    alignItems: "center",
                    border: "1px solid rgba(211, 211, 211, 0.3)",
                  }}
                  key={index}
                >
                  <div
                    style={{
                      flexGrow: 1,
                      flexBasis: 0,
                      padding: "0px 5px",
                      textAlign: "center",
                    }}
                  >
                    {ele["BANK A/C NO"] || "NA"}
                  </div>
                  <div
                    style={{
                      flexGrow: 1,
                      flexBasis: 0,
                      padding: "0px 5px",
                      textAlign: "center",
                      maxWidth: 100,
                    }}
                  >
                    {ele.GM_ifsc}
                  </div>
                  <div
                    style={{
                      flexGrow: 1,
                      flexBasis: 0,
                      padding: "0px 5px",
                      textAlign: "center",
                    }}
                  >
                    {ele["BANK NAME"] || "NA"}
                  </div>
                  <div
                    style={{
                      flexGrow: 1,
                      flexBasis: 0,
                      padding: "0px 5px",
                      textAlign: "center",
                    }}
                  >
                    {ele.UMRNNO || "NA"}
                  </div>
                  <div
                    style={{
                      flexGrow: 1,
                      flexBasis: 0,
                      padding: "0px 5px",
                      textAlign: "center",
                    }}
                  >
                    {ele["MANDATE START DATE"] || "NA"}
                  </div>
                  <div
                    style={{
                      flexGrow: 1,
                      flexBasis: 0,
                      padding: "0px 5px",
                      textAlign: "center",
                    }}
                  >
                    {ele["MANDATE END DATE"] || "NA"}
                  </div>
                  <div
                    style={{
                      flexGrow: 1,
                      flexBasis: 0,
                      padding: "0px 5px",
                      textAlign: "center",
                    }}
                  >
                    {ele.Amt || "NA"}
                  </div>
                  <div
                    style={{
                      flexGrow: 1,
                      flexBasis: 0,
                      padding: "0px 5px",
                      textAlign: "center",
                      color: "#194b7e",
                      fontFamily: "Rubik-Regular",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={this.gotoSIP(ele)}
                  >
                    Select
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div
            style={{
              fontFamily: "Rubik-Regular",
              fontSize: 15,
              color: "#194b7e",
            }}
          >
            There are no ENACH registered for selected Folio. Please{" "}
            <span
              style={{
                fontFamily: "Rubik-Regular",
                fontSize: 15,
                color: "#005DAC",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={this.gotoENACH}
            >
              Click here
            </span>{" "}
            to register to ENACH{" "}
          </div>
        )}
        <div className="mobile-aum-list">
          {details.length > 0
            ? details.map((ele, index) => (
                <InvestorTableCard
                  key={index}
                  bankac={ele["BANK A/C NO"]}
                  ifsc={ele.GM_ifsc}
                  bankname={ele["BANK NAME"]}
                  UMR={ele.UMRNNO}
                  item={ele}
                  gotosip={this.gotoSIP}
                />
              ))
            : null}
        </div>
      </div>
    );
  }
}

export default connect(
  ({ authReducer }) => {
    const { token, userId, fundList, investorData } = authReducer;

    return {
      token,
      userId,
      fundList,
      investorData,
    };
  },
  {
    getEnachFoliosList,
    EnachUMR,
    EnachFolio,
    Enachbank,
    EnachEndDate,
    EnachMaxAmount,
    EnachStartDate,
  }
)(SipEnach);
export class InvestorTableCard extends Component {
  render() {
    const { bankac, ifsc, bankname, UMR, item, gotosip } = this.props;
    return (
      <div
        style={{
          background: "white",
          border: "1px solid rgba(211,211,211,0.3)",
          padding: "7px 10px",
          margin: "10px 0px",
        }}
      >
        <div style={{ display: "flex", padding: "8px 0px" }}>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div
              style={{
                fontFamily: "Rubik-Regular",
                fontSize: 12,
                color: "#005DAC",
              }}
            >
              Bank Account Number
            </div>
            <div
              style={{
                fontFamily: "Rubik-Regular",
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {!!bankac ? bankac : "NA"}
            </div>
          </div>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div
              style={{
                fontFamily: "Rubik-Regular",
                fontSize: 12,
                color: "#005DAC",
              }}
            >
              IFSC Code
            </div>
            <div
              style={{
                fontFamily: "Rubik-Regular",
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {!!ifsc ? ifsc : "NA"}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", padding: "8px 0px" }}>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div
              style={{
                fontFamily: "Rubik-Regular",
                fontSize: 12,
                color: "#005DAC",
              }}
            >
              Bank Name
            </div>
            <div
              style={{
                fontFamily: "Rubik-Regular",
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {!!bankname ? bankname : "NA"}
            </div>
          </div>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div
              style={{
                fontFamily: "Rubik-Regular",
                fontSize: 12,
                color: "#005DAC",
              }}
            >
              UMR No
            </div>
            <div
              style={{
                fontFamily: "Rubik-Regular",
                fontSize: 13,
                color: "#194b7e",
              }}
            >
              {!!UMR ? UMR : "NA"}
            </div>
          </div>
        </div>
        <div style={{ display: "flex", padding: "8px 0px" }}>
          <div style={{ flexGrow: 1, flexBasis: 0 }}>
            <div
              style={{
                fontFamily: "Rubik-Regular",
                fontSize: 12,
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div>Please click "select" to register ENACH SIP</div>
              <div
                style={{
                  color: "#194b7e",
                  fontFamily: "Rubik-Regular",
                  textDecoration: "underline",
                  cursor: "pointer",
                  marginLeft: "5px",
                }}
                onClick={gotosip(item)}
              >
                Select
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
